import { HttpClient } from '@angular/common/http';
import { inject, InjectionToken } from '@angular/core';

import { authInterceptor } from '@rent2end/core/auth';

import { apiClientFactory } from './api-client.factory';
import { CONFIG_API_BASE_URL } from './config-api-base-url.token';

export const CONFIG_API_CLIENT = new InjectionToken<HttpClient>(
  'Config API Client',
  {
    factory: () => apiClientFactory(inject(CONFIG_API_BASE_URL), [authInterceptor])(),
    providedIn: 'root',
  },
);
